/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:36:37
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:45:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/LegalSetting/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Checkbox, Radio } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getLegalSetting,
  onCollapseChange,
  onLegalSettingChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/slice';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { tacPermissions } from '../../Components/hooks/permission';
import css from './css.module.less';
const LegalSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _data: any = useSelector(getLegalSetting());
  const _d = useDispatch();
  const p: any = useParams();
  const { uuid } = p;
  const { canEdit } = tacPermissions(uuid);
  const { setAgreementAsRequired, defaultStatusChecked } = _data || {};

  // const versionRemarksErr = _data[generateErrorKey('versionRemarks')];
  // const entityNameErr = _data[generateErrorKey('entityName')];
  // const entityRegistrationNumberErr =
  //   _data[generateErrorKey('entityRegistrationNumber')];
  // const handleOnRemarksChange = (versionRemarks) => {
  //   _d(onLegalSettingChange({ versionRemarks }));
  // };
  // const handleOnDefaultChange = (useDefaultLegalSetting) => {
  //   _d(onLegalSettingChange({ useDefaultLegalSetting }));
  // };
  // const handleOnEntityNameChange = (entityName) => {
  //   _d(onLegalSettingChange({ entityName }));
  // };
  // const handleOnEntityNumberChange = (entityRegistrationNumber) => {
  //   _d(onLegalSettingChange({ entityRegistrationNumber }));
  // };
  const handleOnAgreementChange = (setAgreementAsRequired) => {
    _d(onLegalSettingChange({ setAgreementAsRequired }));
  };
  const handleOnDefaultStatusChange = (defaultStatusChecked) => {
    const d = !!defaultStatusChecked.target.value;
    _d(onLegalSettingChange({ defaultStatusChecked: d }));
  };
  return (
    <React.Fragment>
      <SectionContent hasBottomBorder>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={
                    <Checkbox
                      checked={setAgreementAsRequired}
                      onChange={handleOnAgreementChange}
                      disabled={!canEdit}>
                      {getI18n(
                        'termsAndCondition.index.setagreementasrequired',
                      )}
                    </Checkbox>
                  }
                  bottomTitle={getI18n(
                    'termsAndCondition.index.setagreementasrequiredbottomtitle',
                  )}>
                  <React.Fragment />
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </SectionContent>
      <SectionContent>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n(
                    'termsAndCondition.index.defaultCheckboxStatus',
                  )}
                  bottomTitle={getI18n(
                    'termsAndCondition.index.defaultCheckboxStatusBottom',
                  )}>
                  <Radio
                    className={css.radioGroup}
                    value={defaultStatusChecked ? 1 : 0}
                    onChange={handleOnDefaultStatusChange}
                    disabled={!canEdit}
                    radioList={[
                      {
                        value: 0,
                        label: getI18n('termsAndCondition.index.unchecked'),
                        className: css.radio,
                      },
                      {
                        value: 1,
                        label: getI18n('termsAndCondition.index.checked'),
                      },
                    ]}
                  />
                </ItemWrapper>
              ),
            },
          ]}
        />
      </SectionContent>
    </React.Fragment>
  );
};

export default SectionHOC(LegalSetting, {
  id: EnumCollapseId.LegalSetting,
  title: getI18nFromGeneral('general.hOCTitle.legalSetting'),
  getCollapse,
  onCollapseChange,
  collapseProps: {},
});
